// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e06a3b24","239":"ba865645","453":"621fd7e7","455":"9e923174"}[chunkId] + ".chunk.js";
};